var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H26C28.2091 0 30 1.79086 30 4V26C30 28.2091 28.2091 30 26 30H4C1.79086 30 0 28.2091 0 26V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 0.5H4C2.067 0.5 0.5 2.067 0.5 4V26C0.5 27.933 2.067 29.5 4 29.5H26C27.933 29.5 29.5 27.933 29.5 26V4C29.5 2.067 27.933 0.5 26 0.5ZM4 0C1.79086 0 0 1.79086 0 4V26C0 28.2091 1.79086 30 4 30H26C28.2091 30 30 28.2091 30 26V4C30 1.79086 28.2091 0 26 0H4Z",
    fill: "#FFDC8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0552 16.4423C23.0503 15.483 23.0466 14.7973 23.0429 14.0429C18.7262 14.0449 14.4503 14.0444 9.9924 14.0451L13.8695 10.168L12.3508 8.64923L5.86003 15.14L12.3574 21.6374L13.822 20.1728L10.076 16.4267C14.4244 16.4311 18.7118 16.4354 23.0552 16.4397L23.0552 16.4423Z",
    fill: "#DEA829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBack);
export default __webpack_public_path__ + "static/media/calendar_back.0cb712e86d37e0caba4d69fa1d1a5580.svg";
export { ForwardRef as ReactComponent };